<template>
  <div class="intro">
    <section class="text-col wide" v-html="getText('intro')[0]"/>
    <div class="manuals text-col">
      <section class="manual">
        <div class="manual-title" v-html="getText('man1')[0]"/>
        <div>
          <div v-html="getText('man1')[1]"/>
          <a class="button" target="_blank" href="/share/SENSES_CoproductionManual_Global.pdf"><span>↓</span>Download</a>
        </div>
      </section>
      <section class="manual">
        <div class="manual-title" v-html="getText('man2')[0]"/>
        <div>
          <div v-html="getText('man2')[1]"/>
          <a class="button" target="_blank" href="/share/SENSES_CoproductionManual_Regional.pdf"><span>↓</span>Download</a>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import cover from '@/assets/data/land-cover'
import { mapGetters } from 'vuex'
export default {
  name: 'intro',
  data () {
    return {
      cover,
      group: null,
      groups: [{
        label: 'Infrastructure',
        color: 'red'
      }, {
        label: 'Cropland',
        color: 'yellow'
      }, {
        label: 'Grazing land',
        color: 'green'
      }, {
        label: 'Used forests',
        color: 'blue'
      }, {
        label: 'Unused land',
        color: 'purple'
      }]
    }
  },
  computed: {
    ...mapGetters(['getText'])
  }
}
</script>
<style lang="scss" scoped>
@import "library/src/style/global.scss";
.intro {
  .manuals {
    padding-top: $spacing / 2;
    display: flex;
    flex-direction: column;
    @include min-width(768px) {
      flex-direction: row;
    }
    .manual {
      flex: 1;
      display: flex;
      flex-direction: column;
      @include min-width(768px) {
        // flex-direction: row;
        &:first-child {margin-right: $spacing;}
        // justify-content: space-between;
      }
      background: getColor(gray, 90);
      margin: 0 0 $spacing 0;
      padding: $spacing / 2;
      border-radius: $border-radius;

      .manual-title {
        margin-bottom: $spacing / 2;
      }
      .button {
        align-self: flex-start;
        text-decoration: none;
        padding: $spacing / 4 $spacing $spacing / 4 $spacing * 0.8;
        margin-top: $spacing / 2;

        &:hover {
          color: $color-white;
        }

        span {
          display: inline-block;
          padding-right: $spacing / 2;
        }
      }
    }
  }
}
</style>
